import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import car from "../images/360/car.webp";
import mobile from "../images/models/mobile.png";
import banners from "../images/models/banner2.webp";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { useTranslation } from 'react-i18next';

function Models() {
  const { t } = useTranslation();

  return (
    <>
      <section className="models-section">
        <HeroPages name={t('models.title')} />
        <div className="container">
          <div className="models-div">
            <div className="models-content__text">
              <h2 style={{ fontSize: "3rem", marginBottom: "2rem" }}>{t('models.subtitle')}</h2>
              <p style={{ fontSize: "1.5rem", lineHeight: "1.7" }}>{t('models.description')}</p>
            </div>
            <div className="models-content__img">
              <img src={require("../images/models/banner.png")} alt="360-vehicle-inspection" height="600" />
            </div>
          </div>
          <div className="iframe-container" style={{ position: "relative", overflow: "hidden", width: "100%", paddingTop: "56.25%" }}>
            <iframe
              src="https://panel.exvrtise.com/carviewer/view/66054eb36f6be67d41000bfb"
              style={{ position: "absolute", top: 0, left: 0, bottom: 0, right: 0, width: "100%", height: "100%", border: "none" }}
              title="360 Vehicle Inspection"
              allowFullScreen
            />
          </div>
          <div className="models-description" style={{ padding: "17.5rem 0", textAlign: "center" }}>
            <h3 style={{ fontSize: "3.5rem", marginBottom: "2rem", color: "#ff4d30" }}>{t('models.features.title')}</h3>
            <div className="description-grid" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "2rem", marginTop: "3rem" }}>
              <div className="description-box">
                <i className="fa-solid fa-magnifying-glass" style={{ fontSize: "3rem", color: "#ff4d30", marginBottom: "1rem" }}></i>
                <h4 style={{ fontSize: "2.1rem", marginBottom: "1rem" }}>{t('models.features.help.title')}</h4>
                <p style={{ fontSize: "1.7rem", lineHeight: "1.6" }}>{t('models.features.help.description')}</p>
              </div>
              <div className="description-box">
                <i className="fa-solid fa-clock" style={{ fontSize: "3rem", color: "#ff4d30", marginBottom: "1rem" }}></i>
                <h4 style={{ fontSize: "2.1rem", marginBottom: "1rem" }}>{t('models.features.technology.title')}</h4>
                <p style={{ fontSize: "1.7rem", lineHeight: "1.6" }}>{t('models.features.technology.description')}</p>
              </div>
              <div className="description-box">
                <i className="fa-solid fa-check" style={{ fontSize: "3rem", color: "#ff4d30", marginBottom: "1rem" }}></i>
                <h4 style={{ fontSize: "2.1rem", marginBottom: "1rem" }}>{t('models.features.effect.title')}</h4>
                <p style={{ fontSize: "1.7rem", lineHeight: "1.6" }}>{t('models.features.effect.description')}</p>
              </div>
            </div>
          </div>
          <div className="customize-container" style={{ backgroundColor: "#ff4d30", padding: "4rem 0", marginTop: "4rem" }}>
            <div className="container" style={{ display: "flex", alignItems: "center", gap: "3rem" }}>
              <div className="customize-text" style={{ flex: "1", color: "white" }}>
                <h3 style={{ fontSize: "2.5rem", marginBottom: "2rem" }}>{t('models.gallery.title')}</h3>
                <p style={{ fontSize: "1.6rem", lineHeight: "1.7" }}>{t('models.gallery.description')}</p>
              </div>
              <div className="customize-iframe" style={{ flex: "1" }}>
                <div className="iframe-wrapper" style={{ position: "relative", paddingTop: "56.25%", height: "0" }}>
                  <iframe
                    src="https://panel.exvrtise.com/carviewer/360/66054eb36f6be67d41000bfb"
                    style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: "none" }}
                    title="Customizable 360 View"
                    allowFullScreen
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="slider-info" style={{ textAlign: "center", marginBottom: "4rem", marginTop: "10rem" }}>
          <h3 style={{ fontSize: "3.5rem", marginBottom: "2rem", color: "#ff4d30" }}>{t('models.rotation.title')}</h3>
          <p style={{ fontSize: "1.8rem", lineHeight: "1.6", maxWidth: "800px", margin: "0 auto" }}>{t('models.rotation.description')}</p>
        </div>
        <div className="slider-section" style={{ position: "relative", padding: "4rem 0", overflow: "hidden" }}>
          <div className="container">
            <div className="background-slider" style={{ position: "relative", width: "100%", height: "500px" }}>
              <Swiper
                navigation={{
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                }}
                modules={[Navigation]}
                className="swiper-container"
                style={{ width: "100%", height: "100%" }}
                loop={true}
                slidesPerView={1}
                allowSlideNext={true}
                allowSlidePrev={true}
                watchSlidesProgress={true}
                loopedSlides={2}
              >
                <SwiperSlide style={{
                  backgroundImage: `url(${require("../images/360/1.webp")})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  width: "100%",
                  height: "100%",
                  borderRadius: "15px"
                }}></SwiperSlide>
                <SwiperSlide style={{
                  backgroundImage: `url(${require("../images/360/2.webp")})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  width: "100%",
                  height: "100%",
                  borderRadius: "15px"
                }}></SwiperSlide>
                <SwiperSlide style={{
                  backgroundImage: `url(${require("../images/360/3.webp")})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  width: "100%",
                  height: "100%",
                  borderRadius: "15px"
                }}></SwiperSlide>
                <SwiperSlide style={{
                  backgroundImage: `url(${require("../images/360/4.webp")})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  width: "100%",
                  height: "100%",
                  borderRadius: "15px"
                }}></SwiperSlide>
                <SwiperSlide style={{
                  backgroundImage: `url(${require("../images/360/5.webp")})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  width: "100%",
                  height: "100%",
                  borderRadius: "15px"
                }}></SwiperSlide>
                <SwiperSlide style={{
                  backgroundImage: `url(${require("../images/360/6.webp")})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  width: "100%",
                  height: "100%",
                  borderRadius: "15px"
                }}></SwiperSlide>

                <div className="swiper-button-next" style={{ color: "#ff4d30", right: "50px" }}></div>
                <div className="swiper-button-prev" style={{ color: "#ff4d30", left: "50px" }}></div>
              </Swiper>

              <div style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 15,
                width: "60%",
                maxWidth: "600px"
              }}>
                <img
                  src={car}
                  alt="Fixed Car"
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain",
                    borderRadius: "15px"
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div style={{
          padding: "8rem 0",
          background: "linear-gradient(90deg, #f8381b 0%, #e18d0f 100%)"
        }}>
          <div className="container">
            <div style={{
              textAlign: "center",
              marginBottom: "4rem"
            }}>
              <h2 style={{
                fontSize: "3.5rem",
                color: "white",
                marginBottom: "2rem"
              }}>{t('models.howToShoot.title')}</h2>
              <p style={{
                fontSize: "1.8rem",
                color: "white",
                maxWidth: "800px",
                margin: "0 auto"
              }}>{t('models.howToShoot.subtitle')}</p>
            </div>

            <div style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "4rem",
              alignItems: "center"
            }}>
              <div>
                <h3 style={{
                  fontSize: "2.5rem",
                  color: "white",
                  marginBottom: "2rem"
                }}>{t('models.howToShoot.standard.title')}</h3>
                <ul style={{
                  listStyle: "none",
                  fontSize: "1.8rem",
                  color: "white",
                  lineHeight: "2"
                }}>
                  {t('models.howToShoot.standard.items', { returnObjects: true }).map((item, index) => (
                    <li key={index}>• {item}</li>
                  ))}
                </ul>
              </div>
              <div>
                <img
                  src={mobile}
                  alt="Car Standard"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "15px"
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div style={{ marginTop: "15rem" }}>
          <div className="container">
            <div style={{
              textAlign: "center",
              marginBottom: "5rem"
            }}>
              <h2 style={{
                fontSize: "3.5rem",
                color: "black",
                marginBottom: "2rem"
              }}>Sales materials</h2>
              <p style={{
                fontSize: "1.8rem",
                color: "black",
                maxWidth: "800px",
                margin: "0 auto"
              }}>
                Accelerate the sales process, increase the effectiveness of your offer
              </p>
            </div>

            <div style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "4rem",
              alignItems: "center"
            }}>
              <div>
                <p style={{
                  fontSize: "1.8rem",
                  color: "black",
                  lineHeight: "1.7",
                  marginBottom: "2rem"
                }}>
                  Support your offers with promotional materials,
                  which will be added automatically when creating a gallery to the offer.
                  Highlight your offer using a personalized overlay
                  or frames and marketing banners.
                </p>
              </div>
              <div>
                <img
                  src={banners}
                  alt="Sales Materials"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "15px"
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="book-banner">
          <div className="book-banner__overlay"></div>
          <div className="container">
            <div className="text-content">
              <h2>Vehicle 360 Inspection</h2>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default Models;
